import debug from 'debug';
import { queryString } from 'Global/Shared/Components/QueryString/QueryString';

const log = debug('InlineView');

class InlineView {
	static getValue() {
		const view = queryString.Get('inline-view');

		if (view === undefined) {
			return sessionStorage.getItem('inline-view');
		}

		if (view === '0') {
			sessionStorage.removeItem('inline-view');
		}
		else {
			sessionStorage.setItem('inline-view', view);
		}

		return view;
	}

	/**
	 * @returns {boolean}
	 */
	static isEnabled() {
		return this.getValue() === '1';
	}
}

export default InlineView;
